export default "__VITE_ASSET__BcZ$YKNL__"